import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../components/CustomComponent.js";
import Barcode from 'react-barcode';
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      printing: true,

      id: "",
      uid: "",
      is_product_code: false,
      is_product_name: false,
      is_product_price: false,
      is_lot_number: false,
      paper_size: "",
      paper_size2: "1",

      product_code: "",
      product_name: "",
      serial_number: "",
      sale_price: "",

      data_Serial: [],
    };
  }

  async componentDidMount() {
    loading(false);
    if (params("uid")) {
      await this.Get();
    } else {
      loading(true);
      let is_product_code,
        is_product_name,
        is_product_price,
        is_lot_number,
        paper_size;

      const result_setting = await GET("admin/setting/barcodes/list", null);
      if (result_setting?.status) {
        is_product_code = result_setting.data?.is_product_code;
        is_product_name = result_setting.data?.is_product_name;
        is_product_price = result_setting.data?.is_product_price;
        is_lot_number = result_setting.data?.is_lot_number;
        paper_size = result_setting.data?.paper_size;
      }
      if (params("serial_number")?.includes(",")) {
        this.setState({
          data_Serial: params("serial_number").split(","),
          product_code: params("product_code"),
          product_name: params("product_name"),
          serial_number: params("serial_number"),
          sale_price: params("sale_price"),
          is_product_code,
          is_product_name,
          is_product_price,
          is_lot_number,
          paper_size,
        });
      } else {
        this.setState({
          product_code: params("product_code"),
          product_name: params("product_name"),
          serial_number: params("serial_number"),
          sale_price: params("sale_price"),
          is_product_code,
          is_product_name,
          is_product_price,
          is_lot_number,
          paper_size,
        });
      }

      loading(false);
    }
    this.Print();
  }
  Get = async () => {
    let data,
      count,
      id,
      uid,
      is_product_code,
      is_product_name,
      is_product_price,
      is_lot_number,
      paper_size,
      product_code,
      product_name,
      serial_number,
      sale_price;
    loading(true);
    let [result, result_setting] = await Promise.all([
      GET("admin/setting/spare-parts/list", {
        uid: params("uid"),
        page: 0,
        data_search: "",
      }),
      GET("admin/setting/barcodes/list", null),
    ]);
    if (result?.status) {
      product_code = result.data.product_code;
      product_name = result.data.product_name;
      serial_number = result.data.serial_number;
      sale_price = result.data.sale_price;
    }
    if (result_setting?.status) {
      is_product_code = result_setting.data.is_product_code;
      is_product_name = result_setting.data.is_product_name;
      is_product_price = result_setting.data.is_product_price;
      is_lot_number = result_setting.data.is_lot_number;
      paper_size = result_setting.data.paper_size;
    }
    this.setState({
      data,
      count,
      is_product_code,
      is_product_name,
      is_product_price,
      is_lot_number,
      paper_size,

      product_code,
      product_name,
      serial_number,
      sale_price,
    });
    loading(false);
  };
  Print = async () => {
    this.setState({ printing: true });
    setTimeout(() => {
      window.print();
      this.setState({ printing: false });
      setTimeout(() => {
        window.close();
      }, 500);
    }, 100);
  };

  render() {
    const {
      data_Serial,
      printing,
      is_product_code,
      is_product_name,
      is_product_price,
      is_lot_number,
      paper_size,
      paper_size2,
      product_code,
      product_name,
      serial_number,
      sale_price,
    } = this.state;
    return (
      <div className="position-relative">
        {!printing && (
          <button
            className="btn btn-primary position-absolute"
            style={{ right: 12, top: 12 }}
            onClick={() => {
              this.Print();
            }}
          >
            พิมพ์เอกสาร
          </button>
        )}
        {data_Serial.length === 0 ? (
          <div
            className="mx-auto bg-white px-3 py-2 pdf"
            style={{
              width: paper_size === "72x26 mm." ? "272.16px" : "264.6px",
              height: paper_size === "72x26 mm." ? "98px" : "189px",
              border: "1px solid #ccc",
              overflow: "hidden",
            }}
          >
            <div className="text-center h-100">
              <div
                style={{
                  height: paper_size === "72x26 mm." ? 45 : 60,
                  overflow: "hidden",
                  marginTop: paper_size === "72x26 mm." ? 0 : 30,
                }}
              >
                <Barcode 
                value={product_code.replaceAll(" ","")}
                width={1.5} 
                />
              </div>
              <div className="text-center" style={{ fontSize: 12, height: 14 }}>
                {is_product_code && (
                  <div
                    className="d-flex justify-content-center"
                    style={{ height: 12 }}
                  >
                    <h6 className="me-2">{product_code}</h6>{" "}
                    {is_product_price ? `${toFixed(sale_price)} บาท` : ""}{" "}
                  </div>
                )}
                {is_product_name && (
                  <div
                    className="overflow-hidden"
                    style={{ height: 14, textOverflow: "ellipsis" }}
                  >
                    {product_name?.replaceAll("@","#")}
                  </div>
                )}
                {is_lot_number && (
                  <div style={{ height: 14 }}>{serial_number}</div>
                )}
              </div>
            </div>
          </div>
        ) : (
          data_Serial.map((item) => (
            <div
              className="mx-auto bg-white px-3 py-2 pdf"
              style={{
                width: paper_size === "72x26 mm." ? "272.16px" : "264.6px",
                height: paper_size === "72x26 mm." ? "98px" : "189px",
                border: "1px solid #ccc",
                overflow: "hidden",
              }}
            >
              <div className="text-center h-100">
                <div
                  style={{
                    height: paper_size === "72x26 mm." ? 45 : 60,
                    overflow: "hidden",
                    marginTop: paper_size === "72x26 mm." ? 0 : 30,
                  }}
                >
                 <Barcode 
                value={product_code.replaceAll(" ","")}
                width={1.5} 
                />
                </div>
                <div
                  className="text-center"
                  style={{ fontSize: 12, height: 14 }}
                >
                  {is_product_code && (
                    <div
                      className="d-flex justify-content-center"
                      style={{ height: 12 }}
                    >
                      <h6 className="me-2">{product_code}</h6>{" "}
                      {is_product_price ? `${toFixed(sale_price)} บาท` : ""}{" "}
                    </div>
                  )}
                  {is_product_name && (
                    <div
                      className="overflow-hidden"
                      style={{ height: 14, textOverflow: "ellipsis" }}
                    >
                      {product_name?.replaceAll("@","#")}
                    </div>
                  )}
                  {is_lot_number && <div style={{ height: 14 }}>{item}</div>}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    );
  }
}
